// src/hooks/useAuditLogger.js
import { useCallback } from 'react';
import { sendAuditEvent } from '../components/AuditLogger.js';

export function useAuditLogger() {
  const logEvent = useCallback(async (eventParams) => {
    return sendAuditEvent(eventParams);
  }, []);

  return { logEvent };
}